module.exports = __webpack_public_path__ + "static/js/0.4314ea8b.chunk.worker.js"